import { t } from '../../localization';

const subdomainTitleList = [
  'hydroitch-jaach-wraufy.yolasite.com',
  'frozencake-taaply-wraufy.yolasite.com',
  'breezypie-jaach-wraufy.yolasite.com',
  'sunnytart-taaply-wraufy.yolasite.com',
  'mistypie-jaach-wraufy.yolasite.com',
];

const processFreeSubdomainData = ({ isUpgradeToPublishEnabled, activeSubscriptionTerm }) => ({
  captions: {
    title: subdomainTitleList[Math.floor(Math.random() * subdomainTitleList.length)],
    button: t('Select'),
    priceDescription: t('Temporary subdomain'),
    popoverContent: t(
      'Randomly generated subdomain to preview your website before connecting a custom domain'
    ),
  },
  ...((!isUpgradeToPublishEnabled || activeSubscriptionTerm) && { buttonFormat: 'outline' }),
});

export default processFreeSubdomainData;
